import React from "react";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { RiDeleteBinLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  increaseCartQty,
  decreaseCartQty
} from "../../features/products/productSlice";
import "./Buttons.css";

/**
 * Component that displays the Buttons page
 *
 * @param {Object} props - The props object containing product information
 * @return {JSX.Element} Buttons component JSX
 */
export default function Buttons(props) {
  const dispatch = useDispatch();
  const { productVariantId, quantity } = props;
  return (
    <div className="basket_buttons">
      {quantity === 1 ? (
        <span
          onClick={() =>
            dispatch(decreaseCartQty({ productVariantId, decrementBy: 1 }))
          }
          className="basket_minus"
        >
          <RiDeleteBinLine />
        </span>
      ) : (
        <span
          onClick={() =>
            dispatch(decreaseCartQty({ productVariantId, decrementBy: 1 }))
          }
          className="basket_minus"
        >
          <AiOutlineMinus />
        </span>
      )}
      <span className="counter_number">{quantity ? quantity : 0}</span>
      <span
        onClick={() =>
          dispatch(increaseCartQty({ productVariantId, incrementBy: 1 }))
        }
        className="basket_plus"
      >
        <AiOutlinePlus />
      </span>
    </div>
  );
}

Buttons.propTypes = {
  productVariantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  quantity: PropTypes.number.isRequired
};
